var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('inner-table',{ref:"leaveList",attrs:{"id":"innerLeave","listviewurl":'student.leaveApplication.listAll',"exclude-fields":'wfNodeNames',"can-edit":0,"can-delete":0,"link-prop-name":'studentId'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }